/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { MENU_ITEMS_BY_PAGE, MENU_ITEM_NAMES } from 'constants/header'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import { getPathWithParams } from 'utils/location'
import * as styles from './HeaderMenu.scss'

interface IItem {
  langPath: string,
  name: MENU_ITEMS_BY_PAGE,
}

interface IProps {
  items: IItem[],
  t: Text,
  onClickMenuItem: (event: React.SyntheticEvent, name: MENU_ITEMS_BY_PAGE) => void,
}

const HeaderMenu: React.FC<IProps> = ({
  items = [],
  t,
  onClickMenuItem,
}) => (
  <ul className={styles.root}>
    {items.map(({ langPath, name }, index) => {
      return (
        <li key={index} className={styles.item}>
          <a
            href={name === MENU_ITEM_NAMES.contactUs
              ? ROUTES.home.contactUs
              : getPathWithParams(ROUTES.home.menu, { menu: langPath })}
            onClick={event => onClickMenuItem(event, name)}
          >
            {t(langPath)}
          </a>
        </li>
      )
    })}
  </ul>
)

export default HeaderMenu
